import { FC } from 'react'
import { Checkbox } from '@microservices/wiskey-react-components'
import { Cell } from '@tanstack/react-table'

import { PINNED_COLUMN } from '@constants'
import { FormattedColumnRestrictions, RESTRICTION_TYPE, RestrictionDTO } from '@types'

interface ShowCellProps {
  cell: Cell<FormattedColumnRestrictions, unknown>
  updateRestrictions: (restrictions: RestrictionDTO[]) => Promise<unknown>
  viewId: number
}

export const ShowCell: FC<ShowCellProps> = ({ cell, updateRestrictions, viewId }) => {
  const columnRestrictions = cell.row.original
  const { fieldCode, fieldName, show, fix } = columnRestrictions
  const isPinned =
    fix?.value === PINNED_COLUMN.LEFT || fix?.value === PINNED_COLUMN.RIGHT
  const isChecked = show?.value === true || show?.value === 'true' || show?.value === undefined

  const handleChange = (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    if (isPinned) {
      return
    }
    updateRestrictions([
      {
        viewId,
        fieldCode,
        fieldName,
        restrictionType: RESTRICTION_TYPE.SHOW,
        value: checked,
      },
    ]).catch(console.error)
  }

  return (
    <Checkbox checked={isChecked} disabled={isPinned} sx={{ height: 30 }} onChange={handleChange} />
  )
}
